import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Sample from "./Sample";
import Install from "./Install";
import Home from "./Home";
import reportWebVitals from "./reportWebVitals";

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import OutfitMethods from "./OutfitMethods";
import Autogenerate from "./Autogenerate";
import MyCloset from "./MyCloset";
import ManualOutfit from "./ManualOutfit";
import AddMethods from "./AddMethods";
import AutoAddResults from "./AutoAddResults";
import CameraScreen from "./CameraScreen.js";
import ManualAddResults from "./ManualAddResults.js";
import EditProfile from "./EditProfile.js";
import FriendsFeed from "./FriendsFeed.js";
import FriendsSearch from "./FriendsSearch.js";
import Friend from "./Friend.js";

function MainSwitch() {
  if ("standalone" in window.navigator && window.navigator.standalone) {
    return <Navigate to="/home" />;
  } else {
    return <Navigate to="/install" />;
  }
}

const router = createBrowserRouter([
  {
    path: "/friend",
    element: <Friend />,
  },
  {
    path: "/friendssearch",
    element: <FriendsSearch />,
  },
  {
    path: "/friendsfeed",
    element: <FriendsFeed />,
  },
  {
    path: "/editprofile",
    element: <EditProfile />,
  },
  {
    path: "/manualaddresults",
    element: <ManualAddResults />,
  },
  {
    path: "/camerascreen",
    element: <CameraScreen />,
  },
  {
    path: "/autoaddresults",
    element: <AutoAddResults />,
  },
  {
    path: "/addmethods",
    element: <AddMethods />,
  },
  {
    path: "/manualoutfit",
    element: <ManualOutfit />,
  },
  {
    path: "/mycloset",
    element: <MyCloset />,
  },
  {
    path: "/autogenerate",
    element: <Autogenerate />,
  },
  {
    path: "/outfitmethods",
    element: <OutfitMethods />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/sample",
    element: <Sample />,
  },
  {
    path: "/install",
    element: <Install />,
  },
  {
    path: "/",
    element: <MainSwitch />,
  },
  {
    path: "*",
    element: <div>Not found</div>,
  },
]);

// I removed strict mode
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
